import FillTheBlankQuestion from "./FillTheBlankQuestion";
import MatchQuestion from "./MatchQuestion";
import OpenEndedQuestion from "./OpenEndedQuestion";
import TestQuestion from "./TestQuestion";
import TrueFalseQuestion from "./TrueFalseQuestion";
import { QuestionTypeEnum } from "../enums";
import {
  FillTheBlankQuestionType,
  MatchQuestionType,
  OpenEndedQuestionType,
  QuestionType,
  TestQuestionType,
  TrueFalseQuestionType,
} from "../types";

type Props = {
  questions?: QuestionType[];
  showAnswers?: boolean;
  questionIndex?: number; // Added to handle index per question
};

const questionRenderer = (
  question: QuestionType,
  showAnswer: boolean,
  index: number,
) => {
  const key = `${question.type}-${index}`;

  switch (question.type) {
    case QuestionTypeEnum.FB:
      return (
        <FillTheBlankQuestion
          key={key}
          question={question as FillTheBlankQuestionType}
          showAnswer={showAnswer}
          questionIndex={index}
        />
      );
    case QuestionTypeEnum.MATCH:
      return (
        <MatchQuestion
          key={key}
          question={question as MatchQuestionType}
          showAnswer={showAnswer}
          questionIndex={index}
        />
      );
    case QuestionTypeEnum.OE:
      return (
        <OpenEndedQuestion
          key={key}
          question={question as OpenEndedQuestionType}
          showAnswer={showAnswer}
          questionIndex={index}
        />
      );
    case QuestionTypeEnum.TEST:
      return (
        <TestQuestion
          key={key}
          question={question as TestQuestionType}
          showAnswer={showAnswer}
          questionIndex={index}
        />
      );
    case QuestionTypeEnum.TF:
      return (
        <TrueFalseQuestion
          key={key}
          question={question as TrueFalseQuestionType}
          showAnswer={showAnswer}
          questionIndex={index}
        />
      );
  }
};

export default function Questions({
  questions,
  showAnswers,
  questionIndex = 0,
}: Props) {
  if (!questions) return null;
  return (
    <>
      {questions.map((question, index) =>
        questionRenderer(question, Boolean(showAnswers), questionIndex + index),
      )}
    </>
  );
}
